/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CategoryListSub model module.
 * @module model/CategoryListSub
 * @version 1.0
 */
class CategoryListSub {
    /**
     * Constructs a new <code>CategoryListSub</code>.
     * @alias module:model/CategoryListSub
     */
    constructor() { 
        
        CategoryListSub.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CategoryListSub</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CategoryListSub} obj Optional instance to populate.
     * @return {module:model/CategoryListSub} The populated <code>CategoryListSub</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CategoryListSub();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('subNo')) {
                obj['subNo'] = ApiClient.convertToType(data['subNo'], 'Number');
            }
            if (data.hasOwnProperty('pageUrl')) {
                obj['pageUrl'] = ApiClient.convertToType(data['pageUrl'], 'String');
            }
            if (data.hasOwnProperty('key')) {
                obj['key'] = ApiClient.convertToType(data['key'], 'String');
            }
            if (data.hasOwnProperty('readonly')) {
                obj['readonly'] = ApiClient.convertToType(data['readonly'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CategoryListSub</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CategoryListSub</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['pageUrl'] && !(typeof data['pageUrl'] === 'string' || data['pageUrl'] instanceof String)) {
            throw new Error("Expected the field `pageUrl` to be a primitive type in the JSON string but got " + data['pageUrl']);
        }
        // ensure the json data is a string
        if (data['key'] && !(typeof data['key'] === 'string' || data['key'] instanceof String)) {
            throw new Error("Expected the field `key` to be a primitive type in the JSON string but got " + data['key']);
        }

        return true;
    }


}



/**
 * @member {String} name
 */
CategoryListSub.prototype['name'] = undefined;

/**
 * @member {Number} subNo
 */
CategoryListSub.prototype['subNo'] = undefined;

/**
 * @member {String} pageUrl
 */
CategoryListSub.prototype['pageUrl'] = undefined;

/**
 * @member {String} key
 */
CategoryListSub.prototype['key'] = undefined;

/**
 * @member {Boolean} readonly
 */
CategoryListSub.prototype['readonly'] = undefined;






export default CategoryListSub;

